(function($) {
  'use strict';

  var defaults = {
  // Wrapper class, otherwise .parent() will be used
    wrapper: null,
    // input selector
    input: 'input, textarea',
    // class to be added to inputs with values
    filledClass: 'filled',
    // class to be added to inputs with focus
    focusedClass: 'focused',
    // Removes placeholder from inputs
    removePlaceholder: true,
    // Prepend for added classes
    prepend: 'js-float-labels-',
    // Filter out inputs which would get messed up by floating labels, add your own if this list gets out of date
    filter: '[type="checkbox"], [type="submit"], [type="hidden"], [type="image"], [type="button"], [type="image"], [type="date"]'
  };

  // For Chrome autofill, since it doesn't fire a change
  var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') !== -1;

  // Make sure we don't duplicate id's
  var time = (new Date()).getTime();
  var getIdI = 0;

  var getId = function() {
    return time += getIdI++; // eslint-disable-line no-plusplus
  };

  // Adds a filled class to an input's wrapper
  var updateInput = function(input, settings, addParentClass) {
    // eslint-disable-next-line no-param-reassign
    addParentClass = addParentClass || false;

    var $input = $(input);
    if ($input.is(settings.filter)) {
      return;
    }

    var $wrapper = (settings.wrapper) ? $input.closest(settings.wrapper) : $input.parent();

    if (!$wrapper.length) {
      return;
    }

    // Compensate for no labels
    var $label = $wrapper.find('label');
    if (!$label.length) {
    // Compensate for no id
      var id = input.id || $input.attr('id', settings.prepend + 'input-' + getId()).attr('id');
      $label = $('<label/>')
        .html(input.placeholder || input.name)
        .attr('for', id)
      ;
      $wrapper.prepend($label);
    }

    if (settings.removePlaceholder && $input.attr('placeholder')) {
      $input.attr({ placeholder: '' });
    }

    setTimeout(function() {
      if ($input.is(':focus') && $input.val()) {
        $wrapper.addClass(settings.focusedClass);
      } else {
        $wrapper.removeClass(settings.focusedClass);
      }

      // Because lol jQuery 1.9
      if ($input.val() !== '' || (isChrome && $input[0].matches && $input[0].matches(':-webkit-autofill'))) {
        $wrapper.addClass(settings.filledClass);
      } else {
        $wrapper.removeClass(settings.filledClass);
      }
    }, 0);

    if (addParentClass) {
      $wrapper.addClass(settings.prepend + 'wrapper');
    }
  };

  // delegated inputs
  var delegates = [];
  var intervals = [];

  // plugin
  $.fn.floatLabels = function(params) { // eslint-disable-line no-param-reassign
    var settings = $.extend({}, defaults, params);
    var $this = this;
    var $inputs = (settings.wrapper) ? $this.find(settings.wrapper).find(settings.input) : $this.find(settings.input);
    var events = 'focus blur propertychange change click keyup input paste';

    var fn = function() {
      updateInput(this, settings);
    };

    var key = $this.selector + '|' + settings.input;

    // Don't double up on events
    if (delegates[key] !== undefined) {
      $this.undelegate(settings.input, events, delegates[key]);
      clearInterval(intervals[key]);
    }

    delegates[key] = fn;

    // The interval will check for js changing the value, or browser auto fills, etc
    intervals[key] = setInterval(function() {
      $inputs.each(fn);
    }, 200);

    // Otherwise these events will instantly update the field
    $this
      .delegate(settings.input, events, fn)
    ;

    $inputs.each(function() {
      updateInput(this, settings, true);
    })
    ;

    return $this;
  };
}(window.jQuery || window.Zepto || window.$));
